export default __webpack_public_path__ + "static/media/project_board_lg.5143d75a.jpg";